//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapStores } from 'pinia'
import { useXeroStore } from '~/store/xero'

export default {
    name: 'CreateBankAccountCard',
    computed: {
        ...mapStores(useXeroStore),
    },
    methods: {
        updateBankDetailsPanel() {
            this.xeroStore.updateBankDetailsPanel(3)
            this.$emit('close-dialog')
        },
    },
}
